import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ShoppingCart, CheckCircle2, ArrowRight, CreditCard, Package, TrendingUp, Truck } from 'lucide-react';

const ECommerce = () => {
  const features = [
    { icon: ShoppingCart, title: 'Shop-Systeme', desc: 'Shopify, WooCommerce oder individuelle Lösungen' },
    { icon: CreditCard, title: 'Zahlungsabwicklung', desc: 'Alle gängigen Zahlungsmethoden integriert' },
    { icon: Package, title: 'Warenwirtschaft', desc: 'Bestandsverwaltung und Fulfillment' },
    { icon: TrendingUp, title: 'Analytics', desc: 'Verkaufsanalysen und Conversion-Tracking' },
  ];

  const packages = [
    { name: 'Starter Shop', price: '3.990', features: ['Bis 100 Produkte', 'Standard-Theme', 'Zahlungsintegration', 'SSL-Zertifikat'] },
    { name: 'Business Shop', price: '7.990', features: ['Bis 1.000 Produkte', 'Custom Design', 'Multi-Payment', 'SEO-Optimierung', 'Newsletter'], popular: true },
    { name: 'Enterprise', price: 'Auf Anfrage', features: ['Unbegrenzt Produkte', 'Individuelle Entwicklung', 'ERP-Integration', 'Multi-Channel', '24/7 Support'] },
  ];

  return (
    <div>
      {/* Hero */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-slate-900 via-emerald-900 to-slate-900 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-20 right-20 w-64 h-64 bg-emerald-500/20 rounded-full blur-3xl" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-300 text-sm font-medium mb-6">
              <ShoppingCart size={16} />
              E-Commerce Lösungen
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
              Online-Shops, die verkaufen
            </h1>
            <p className="text-xl text-slate-300 leading-relaxed mb-8">
              Professionelle E-Commerce-Lösungen für Ihren erfolgreichen Online-Handel.
            </p>
            <Link to="/kontakt">
              <Button size="lg" className="bg-emerald-600 hover:bg-emerald-700 text-white">
                Shop planen
                <ArrowRight className="ml-2" size={18} />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((f, i) => (
              <Card key={i} className="border-0 shadow-lg">
                <CardContent className="p-6 text-center">
                  <div className="w-14 h-14 rounded-xl bg-emerald-100 flex items-center justify-center mx-auto mb-4">
                    <f.icon className="text-emerald-600" size={28} />
                  </div>
                  <h3 className="font-semibold text-slate-900 mb-2">{f.title}</h3>
                  <p className="text-sm text-slate-600">{f.desc}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Packages */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900">Shop-Pakete</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {packages.map((pkg, i) => (
              <Card key={i} className={`border-2 ${pkg.popular ? 'border-emerald-600 shadow-xl' : 'border-slate-200'} relative`}>
                {pkg.popular && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-emerald-600 text-white px-4 py-1 rounded-full text-sm">Empfohlen</div>}
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-slate-900 mb-4">{pkg.name}</h3>
                  <div className="text-3xl font-bold text-slate-900 mb-6">{pkg.price}{pkg.price !== 'Auf Anfrage' && '€'}</div>
                  <ul className="space-y-3 mb-6">
                    {pkg.features.map((f, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-slate-600">
                        <CheckCircle2 className="text-green-500" size={16} />{f}
                      </li>
                    ))}
                  </ul>
                  <Link to="/kontakt">
                    <Button className={`w-full ${pkg.popular ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-slate-900 hover:bg-slate-800'} text-white`}>
                      Anfragen
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ECommerce;
